/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum FloorRecognitionProcessingStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum ConnectionTypeId {
  PORT = 1,
  CABLE = 2,
  BUS = 3,
  PLAIN_TEXT = 4,
}

export enum WorkHourPriceType {
  Installation = "installation",
  Personalisation = "personalisation",
}

export enum WorkHourPriceCurrency {
  Huf = "huf",
  Eur = "eur",
  Gbp = "gbp",
  Usd = "usd",
  Czk = "czk",
  Pln = "pln",
  Chf = "chf",
}

export enum ProfileImageType {
  Avatar = "avatar",
  Logo = "logo",
}

export interface CreateLabelRequest {
  label_name: string;
  label_color: string;
}

export type CreateLabelResponse = ApiResponse & {
  label?: UserLabels | null;
};

export interface CreateProjectRequest {
  project_id?: number | null;
  project_name: string;
  country: string;
  city?: string | null;
  street_address?: string | null;
  zip_code?: string | null;
  comment?: string | null;
  drive_link?: string | null;
  labelIds?: number[];
}

export type CreateProjectResponse = ApiResponse & {
  message: string;
  id: number;
};

export type DeleteFloorResponse = ApiResponse & {
  message: string;
};

export interface DeviceCategory {
  name: string;
  subcategories: DeviceSubcategory[];
}

export interface DeviceItem {
  id: string;
  text: string;
  icon?: string | null;
  image?: string | null;
  input: boolean;
  groupable: boolean;
  serializable: boolean;
  mergeable: boolean;
  is_loxone: boolean;
  product_id: number;
  has_design: boolean;
  is_nhc: boolean;
  device_manufacturer: string;
  device_color: string;
  image_url: string | null;
  note_message: string;
  max_serializable: number;
}

export interface DeviceSubcategory {
  id: number;
  name: string;
  icon: string | null;
  devices: DeviceItem[];
}

/** Floor data with embedded outerWalls and rooms */
export interface ExportFloorDto {
  floor: Floors;
  outerWalls: OuterWallPolies[];
  rooms: ExportRoomDto[];
}

/** Room data with embedded wallPolies, doors and windows */
export interface ExportRoomDto {
  /** Room model */
  room: Rooms;
  wallPolies: WallPolies[];
  doors: SegmentParts[];
  windows: SegmentParts[];
  room_type_name?: string;
}

export type FloorsExportResponse = ApiResponse & {
  /** Array of floors with outerWalls and rooms embedded */
  floors: ExportFloorDto[];
};

export type GetAutoplanTutorialStatusResponse = ApiResponse & {
  completed: boolean;
};

export type GetBillingDataResponse = ApiResponse & {
  country: string;
  city: string;
  zipcode: string;
  street_address: string;
  company: string;
  tax_number: string;
  /** True when every field required for a Stripe checkout is filled. */
  is_filled: boolean;
};

export type GetDevicesOfProjectResponse = ApiResponse & {
  categories: DeviceCategory[];
};

export type GetFloorRoomsAndRelatedObjectsResponse = ApiResponse & {
  floor: Floors;
  rooms: GetFloorRoomsRoom[];
  devices: GetFloorRoomsDevice[];
  groups: GetFloorRoomsSerialUgroup[];
  serials: GetFloorRoomsSerial[];
  serial_connections: GetFloorRoomsSerialConnection[];
  additional_items: commonModelsFloorsAdditionalItems[];
  room_user_custom_items: GetFloorRoomsRoomUserCustomItem[];
  measurement_types: commonModelsMeasurementTypes[];
  measurements: commonModelsMeasurements[];
  outer_wall_polies: OuterWallPolies[];
  postits: commonModelsPostits[];
  floor_outdoor_room_id: number;
  camera_values: GetFloorRoomsCameraValues[];
  merged_device: commonModelsMergedProduct[];
  /** @format float */
  planner_opacity: number;
};

export interface GetFloorsRequest {
  project_id: number;
}

export type GetFloorsResponse = ApiResponse & {
  /** array<string, mixed>> */
  floors: Floors[];
};

export type GetLabelsResponse = ApiResponse & {
  /** array<string, mixed>> */
  labels: UserLabels[];
};

export type GetModalFlagsResponse = ApiResponse & {
  show_checklist_modal: boolean;
  show_room_detected_modal: boolean;
  show_auto_planning_modal: boolean;
};

export type GetMyProductResponse = ApiResponse & {
  product: MyProduct;
};

export type GetMyProductsResponse = ApiResponse & {
  products: MyProduct[];
};

export type GetParticipantListsResponse = ApiResponse & {
  lists: ParticipantListItem[];
  /** The roles a participant can get, with translated names. */
  roles: SettingsOption[];
};

export type GetPaymentStatusResponse = ApiResponse & {
  is_active_subscription: boolean;
  is_active_payment: boolean;
  has_volume_license: boolean;
  has_ongoing_sub: boolean;
  /** int|float|string> */
  prices: Record<string, number | string | boolean>;
  subscribe_price: number;
  pro_license_date: string;
  coupon?: any;
};

export type GetProductsOfRoomsByFloorsResponse = ApiResponse & {
  floors: GetProductsOfRoomsByFloorsFloor[];
};

export interface GetProductsOfRoomsByFloorsFloor {
  floor_id: number;
  floor_name: string;
  rooms: GetProductsOfRoomsByFloorsRoom[];
}

export interface GetProductsOfRoomsByFloorsRoom {
  room_id: number;
  room_name: string;
  room_type: string;
  products: GetProductsOfRoomsByFloorsProduct[];
}

export interface GetProductsOfRoomsByFloorsProduct {
  product_id: number;
  name: string;
  icon_path: string;
  x: number;
  y: number;
}

export type GetProfileSettingsResponse = ApiResponse & {
  profile: ProfileSettingsData;
  /** The user's own service fees, or the admin defaults when the user has not set any yet. */
  work_hour_prices: ProfileSettingsWorkHourPrice[];
  /** The service fee section is only shown when the admin has set a default fee in every currency. */
  show_work_hour_prices: boolean;
  work_hour_info_link: string;
  is_pro_license_valid: boolean;
  /** Raw expiration datetime of the pro license, empty when not set. */
  pro_expiration_date: string;
  options: ProfileSettingsOptions;
};

export interface GetProjectResponseProject {
  project: Projects;
  own: boolean;
  readOnly: boolean;
  occupationTypeId: number;
  paidFeature?: PaidFeature | null;
  userRole: string;
  labels: UserLabels[];
}

export type GetProjectSettingsResponse = ApiResponse & {
  electrical: ProjectSettingsElectrical;
  wizard: ProjectSettingsWizard;
  options: ProjectSettingsOptions;
  /** The Niko Home Controller field is only shown to Belgian users. */
  show_nhc_max_unit_number_in_row: boolean;
};

export type GetProjectUsersResponse = ApiResponse & {
  owner: ProjectUserContact | null;
  occupations: ProjectUserOccupation[];
  roles: ProjectRole[];
};

export type GetProjectsResponse = ApiResponse & {
  projects: GetProjectResponseProject[];
};

export type GetRoomTypesResponse = ApiResponse & {
  roomTypes: RoomTypes[];
};

export type IsLoxoneAvailableResponse = ApiResponse & {
  is_loxone_config_download_available: boolean;
};

export interface MigrateToFoldersRequest {
  /**
   * Start date for selecting projects (inclusive).
   * @format date-time
   * @example "2025-01-01 00:00:00"
   */
  fromDate: string;
  /**
   * End date for selecting projects (inclusive).
   * @format date-time
   * @example "2025-10-10 23:59:59"
   */
  toDate: string;
}

export interface MoveProjectToFolderRequest {
  projectId?: number;
  projectGroupId?: number;
}

export interface SaveBillingDataRequest {
  country: string;
  city: string;
  zipcode: string;
  street_address: string;
  company?: string | null;
  tax_number?: string | null;
}

export interface UpdateModalFlagsRequest {
  show_checklist_modal?: boolean | null;
  show_room_detected_modal?: boolean | null;
  show_auto_planning_modal?: boolean | null;
}

export interface UpsertFloorRequest {
  floorId?: number | null;
  projectId: number;
  floorName: string;
  headroom: string;
  lengthProportion: string;
  /** @format binary */
  planImage?: File;
}

export type UpsertFloorResponse = ApiResponse & {
  id: number;
};

export interface GetFloorRoomsCameraValues {
  id: number;
  horizontal: string;
  vertical: string;
}

export interface GetFloorRoomsDevice {
  deviceId: number;
  image: string;
  roomId: number;
  /** @format float */
  x: number;
  /** @format float */
  y: number;
  /** @format float */
  rotate_value: number;
  input: boolean;
  groupable: boolean;
  serializable: boolean;
  mergeable: boolean;
  product_id: number;
  has_design: boolean;
  is_nhc: boolean;
  device_manufacturer: string;
  device_color: string;
  is_loxone: boolean;
  image_url: string;
  category_id: number;
  product_name_id: number;
  symbol_id: string;
  max_serializable: number;
}

export interface GetFloorRoomsRoom {
  id: number;
  /** @format float */
  room_airspace: number;
  /** @format float */
  room_area: number;
  /** @format float */
  room_headroom: number;
  room_type_id: number;
  roomname: string;
  poly: WallPolies[];
}

export interface GetFloorRoomsRoomUserCustomItem {
  id: number;
  image: string;
  image_color?: string;
  roomId: number;
  /** @format float */
  rotate_value: number;
  user_custom_item_id: number;
  /** @format float */
  x: number;
  /** @format float */
  y: number;
}

export interface GetFloorRoomsSerial {
  id: number;
  deviceIds: number[];
  direction: string;
  /** @format float */
  height: number;
}

export interface GetFloorRoomsSerialConnection {
  id: number;
  serialIds: number[];
}

export interface GetFloorRoomsSerialUgroup {
  deviceIds: number[];
  id: number;
}

export interface ChangePasswordRequest {
  current_password: string;
  password: string;
  password_repeat: string;
}

export interface ParticipantListItem {
  id: number;
  name: string;
  participants: ParticipantListParticipant[];
}

export interface ParticipantListParticipant {
  id: number;
  email: string;
  role_id: number;
}

export interface ProfileSettingsData {
  first_name: string;
  last_name: string;
  website: string;
  email: string;
  company: string;
  tax_number: string;
  country: string;
  city: string;
  street_address: string;
  zipcode: string;
  telephone: string;
  site_language: string;
  preferred_currency_id: number;
  planner_icon_set_id: number;
  /** File name under images/avatars/, empty when not set. */
  user_avatar_link: string;
  /** Company logo file name under images/avatars/, empty when not set. */
  user_company_link: string;
}

export interface ProfileSettingsLanguageOption {
  code: string;
  name: string;
}

export interface ProfileSettingsOptions {
  site_languages: ProfileSettingsLanguageOption[];
  currencies: SettingsOption[];
  icon_sets: SettingsOption[];
}

export interface ProfileSettingsWorkHourPrice {
  type: WorkHourPriceType;
  /** @format float */
  huf: number;
  /** @format float */
  eur: number;
  /** @format float */
  gbp: number;
  /** @format float */
  usd: number;
  /** @format float */
  czk: number;
  /** @format float */
  pln: number;
  /** @format float */
  chf: number;
}

export interface SaveProfileSettingsRequest {
  first_name: string;
  last_name: string;
  website: string;
  email: string;
  company: string;
  tax_number: string;
  country: string;
  city: string;
  street_address: string;
  zipcode: string;
  telephone: string;
  site_language: string;
  preferred_currency_id: number;
  planner_icon_set_id: number;
}

export interface SaveWorkHourPricesRequest {
  /** The currency the fees are given in, the other currencies are calculated from it. */
  currency: WorkHourPriceCurrency;
  /** @format float */
  installation: number;
  /** @format float */
  personalisation: number;
}

export interface SubmitFeedbackSurveyRequest {
  /** Overall satisfaction, 1-5 stars. */
  overall: number;
  /** Option id of the cancel reason select, the last option is "Other". */
  cancel_reason: number;
  cancel_reason_text?: string | null;
  /** Option id of the most useful feature select, the last option is "Other". */
  useful_feature: number;
  useful_feature_text?: string | null;
  /** Would recommend uPlan, 1-5 stars. */
  would_recommend: number;
  improve_text?: string | null;
}

export type UploadProfileImageResponse = ApiResponse & {
  /** File name under images/avatars/. */
  file_name: string;
};

export interface ProjectSettingsElectrical {
  supply_type_id: number;
  supply_cable_type_id: number;
  supply_profile_id: number;
  main_switch_value_id: number;
  main_switch_type_id: number;
  overvoltage_protection_type_id: number;
  protection_before_overvoltage_protection_value_id: number;
  supply_as_terminal_block_check: boolean;
  service_socket: boolean;
  main_switch_check: boolean;
  overvoltage_protection_check: boolean;
  protection_before_overvoltage_protection_check: boolean;
  supply_label: string;
  supply_note: string;
  nhc_max_unit_number_in_row?: number | null;
}

export interface ProjectSettingsElectricalOptions {
  supply_type_id: SettingsOption[];
  supply_cable_type_id: SettingsOption[];
  supply_profile_id: SettingsOption[];
  main_switch_value_id: SettingsOption[];
  main_switch_type_id: SettingsOption[];
  overvoltage_protection_type_id: SettingsOption[];
  protection_before_overvoltage_protection_value_id: SettingsOption[];
}

export interface ProjectSettingsOptions {
  electrical: ProjectSettingsElectricalOptions;
  wizard: ProjectSettingsWizardOptions;
  measurement_systems: SettingsOption[];
  icon_sets: SettingsOption[];
}

export interface ProjectSettingsWizard {
  switch_product_name_id: number;
  lighting_product_name_id: number;
  shading_product_name_id: number;
  heating_product_name_id: number;
  contact_sensor_product_name_id: number;
  movement_sensor_product_name_id: number;
  wifi_hertz: number;
  ventillation_product_name_id: number;
}

export interface ProjectSettingsWizardOptions {
  switch_product_name_id: SettingsOption[];
  lighting_product_name_id: SettingsOption[];
  shading_product_name_id: SettingsOption[];
  heating_product_name_id: SettingsOption[];
  contact_sensor_product_name_id: SettingsOption[];
  movement_sensor_product_name_id: SettingsOption[];
  wifi_hertz: SettingsOption[];
  ventillation_product_name_id: SettingsOption[];
}

export interface SettingsOption {
  id: number;
  name: string;
}

export interface ProjectRole {
  id: number;
  name: string;
}

export interface ProjectUserContact {
  user_id: number;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  telephone: string;
  user_avatar_link: string | null;
}

export interface ProjectUserOccupation {
  contact: ProjectUserContact;
  role_id: number;
  role_name: string;
  has_accepted_registration_invite: boolean;
  has_user_accepted_occupation: boolean;
}

export type InstallationCablingResponse = ApiResponse & {
  buses: Bus[];
  devices: Device[];
  cables: Cable[];
  connection_types: ConnectionType[];
  resistors: Resistor[];
  /** Cable type id => cable type name */
  cable_types: Record<string, string>;
  tree_lines: TreeBus[];
  /** UUIDs of devices that start a new page */
  pageBreakBefore: string[];
};

export interface Bus {
  id: string;
  busName: string;
  devices: BusDevice[];
  /** UUID of the base device the bus belongs to */
  base_device?: string | null;
  /** Bus type hint for the one wire schematic, e.g. air, rs232 */
  type?: string | null;
}

export interface BusDevice {
  imageUrl: string;
  displayText: string;
  icon?: string | null;
  product_name_id?: number | null;
}

export interface Cable {
  cableID: string;
  cableName: string;
  /** Key of cable_types */
  cableTypeID: number;
  /** Hex color */
  cableColor: string;
  beginningPort?: Port | null;
  endingPort?: Port | null;
}

export interface Connection {
  sourceId: string;
  sourceTypeId: ConnectionTypeId;
  targetId: string;
  targetTypeId: ConnectionTypeId;
  additionalText: string;
  textRotation: number;
  textOrientation: string;
  icon?: string | null;
  product_id?: number | null;
  product_name_id?: number | null;
  room_id?: number | null;
}

export interface ConnectionType {
  id: ConnectionTypeId;
  /** port, cable, bus or plainText */
  type: string;
}

export interface Device {
  /** UUID of the base device */
  id: string;
  /** Product name */
  text: string;
  imageUrl: string;
  originalImageWidth?: number | null;
  originalImageHeight?: number | null;
  inputs: DeviceInput[];
  connections: Connection[];
  labels: string[];
  /** Groups of port IDs drawn as one menorah */
  menorahGroups: string[][];
}

export interface DeviceInput {
  portID: string;
  /** @format float */
  xPosition: number;
  /** @format float */
  yPosition: number;
  label: DeviceInputLabel;
  /** up or down */
  portOrientation: string;
}

export interface DeviceInputLabel {
  displayName: string;
}

export interface Port {
  deviceId: string;
  portId: string;
}

export interface Resistor {
  cableID1: string;
  cableID2: string;
  /** Text under the resistor, usually its resistance */
  text: string;
}

export interface TreeBus {
  name: string;
  extensions: TreeExtension[];
}

export interface TreeDevice {
  /** Product image url */
  image: string;
  /** Drawing name of the plan object */
  text: string;
  wireNum: number;
  /** 0 for synthetic devices like dimmers and power supplies */
  plan_object_id: number;
  product_id?: number | null;
  product_name_id?: number | null;
  priority?: number | null;
  /** e.g. dimmer, power supply & backup */
  type?: string | null;
}

export interface TreeExtension {
  id: string;
  /** Miniserver Tree or Tree extension */
  name: string;
  lines: TreeLine[];
}

export interface TreeLine {
  id: string;
  name: string;
  wires: TreeWire[];
}

export interface TreeWire {
  id: string;
  /** Cable type name, e.g. LOXONE TREE cable */
  type: string;
  devices: TreeDevice[];
}

export interface TectlyAnnouncementRequest {
  uPlanProjectIds: number[];
}

export type TectlyDocumentUploadResponse = ApiResponse & {
  /** ID of the uploaded document (UUID) */
  documentId: string;
  /** Original file name */
  originalFileName?: string | null;
  /** Content type of the document */
  contentType?: string | null;
  /** Processing status */
  processingStatus?: string | null;
  /** ID of the automatically created floor (UUID) */
  tectlyFloorId?: string;
};

export type TectlyFloorResultsResponse = ApiResponse;

export type TectlyFloorStatusResponse = ApiResponse & {
  /** Floor ID (UUID) */
  floorId: string;
  /** Plan ID (UUID) */
  planId: string;
  /** Document page ID (UUID) */
  documentPageId?: string | null;
  /** Wall processing status */
  wallProcessingStatus?: FloorRecognitionProcessingStatus;
  /** Wall opening (doors, windows) processing status */
  wallOpeningProcessingStatus?: FloorRecognitionProcessingStatus;
  /** Room processing status */
  roomProcessingStatus?: FloorRecognitionProcessingStatus;
  /** Horizontal scale processing status */
  horizontalScaleProcessingStatus?: FloorRecognitionProcessingStatus;
  /** Post processing status */
  postProcessingStatus?: FloorRecognitionProcessingStatus;
};

export type TectlyMonthlyLimitResponse = ApiResponse & {
  /** Global monthly automatic room recognition limit applied to every user */
  monthlyLimit: number;
};

export type TectlyProjectCreationResponse = ApiResponse & {
  tectlyProjectId?: string;
};

export interface LineDto {
  /** $fromCoordinate */
  fromCoordinate?: number[];
  /** $toCoordinate */
  toCoordinate?: number[];
}

export interface RoomDto {
  roomEntityId?: number;
  roomName?: string;
  roomTypeId?: number;
  /** @format float */
  area?: number;
}

export interface RoomWithWallsDto {
  room?: RoomDto;
}

export interface WallPolyDto {
  wallPolyEntityId?: number;
  type?: "INNER" | "OUTER";
  orderIndex?: number;
  /** @format float */
  x?: number;
  /** @format float */
  y?: number;
}

export interface WallSegmentDto {
  segmentPartEntityId?: number;
  type?: string;
  /** $fromCoordinate */
  fromCoordinate?: number[];
  /** $toCoordinate */
  toCoordinate?: number[];
  wall?: WallPolyDto;
  room?: RoomDto;
}

export interface WallSegmentGroupDto {
  segmentGroupEntityId?: number;
  segmentEntityId?: number;
  wallSegments?: WallSegmentDto[];
}

export interface ExampleRequest {
  prop1: string;
  prop2?: number;
  item?: ExampleRequestItem;
}

export interface ExampleRequestItem {
  name: string;
  value?: number;
}

export type ExampleResponse = ApiResponse & {
  boolProperty?: boolean;
  items?: ExampleResponseItem[];
};

export interface ExampleResponseItem {
  stringPropety?: string;
}

export interface ApiResponse {
  success: boolean;
  errorMessage?: string | null;
  errorCode?: string | null;
  /** string>|null $errorParams */
  errorParams?: object | null;
}

export interface Floors {
  /** This is the model class for table "floors". */
  id?: number;
  project_id?: number;
  floor_uploaded_file_id?: number;
  icon_size?: number;
  floor_name: string;
  plan_image?: string;
  room_name_visible?: boolean;
  grid_visible?: boolean;
  /** @format double */
  headroom: number;
  /** @format double */
  length_proportion?: number;
  /** @format double */
  ratio_coordx1?: number;
  /** @format double */
  ratio_coordy1?: number;
  /** @format double */
  ratio_coordx2?: number;
  /** @format double */
  ratio_coordy2?: number;
  is_scale_checked?: number;
}

export interface MyProduct {
  userCustomItem: UserCustomItems;
  icon_svg: string;
  icon_color: string;
}

/** Outer wall polygon point */
export interface OuterWallPolies {
  /** This is the model class for table "outer_wall_polies". */
  id: number;
  floor_id: number;
  order_index: number;
  /** @format double */
  x: number;
  /** @format double */
  y: number;
}

export interface PaidFeature {
  loxoneconfig_paid: boolean;
  dxf_paid: boolean;
  stromlaufplan_paid: boolean;
  is_loxone_config_download_available: boolean;
}

export interface ProjectLabels {
  project_id: number;
  label_id: number;
}

export interface Projects {
  id: number;
  project_owner_user_id: number;
  project_name: string;
  country: string;
  street_address: string;
  city: string;
  comment: string;
  zip_code: string;
  drive_link: string;
  general_info: string;
  drawing_number: number;
  preferred_currency_id: number;
  /** @format float */
  devices_discount: number;
  /** @format float */
  services_discount: number;
  /** @format float */
  tax_value: number;
  /** @format float */
  planner_opacity: number;
  system_of_measurement_id: number;
  planner_icon_set_id: number;
  is_sample: number;
  tectly_project_id: string | null;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export interface RoomTypes {
  /** This is the model class for table "room_types". */
  id: number;
  room_type_name: string;
}

/** Room model */
export interface Rooms {
  /** This is the model class for table "rooms". */
  id: number;
  floor_id: number;
  room_name?: string;
  room_type_id: number;
  /** @format double */
  headroom?: number;
  /** @format double */
  airspace?: number;
  /** @format double */
  area?: number;
}

/** Segment part (door/window) model */
export interface SegmentParts {
  /** This is the model class for table "segment_parts". */
  id: number;
  /** @format double */
  x1: number;
  /** @format double */
  y1: number;
  /** @format double */
  x2: number;
  /** @format double */
  y2: number;
  room_id: number;
  /** @maxLength 10 */
  type_name?: string;
  wallgroup_id?: number;
}

export interface User {
  /** User model */
  id: number;
  username: string;
  first_name?: string;
  last_name?: string;
  password_hash?: string;
  password_reset_token?: string | null;
  confirm_user_token?: string | null;
  delete_user_token?: string | null;
  email: string;
  auth_key?: string;
  status?: number;
  new_user?: boolean;
  created_at?: number;
  updated_at?: number;
  first_login_at?: number | null;
  password?: string;
  invitation_token?: string | null;
  website?: string | null;
  company?: string | null;
  tax_number?: string | null;
  country?: string | null;
  city?: string | null;
  street_address?: string | null;
  zipcode?: string | null;
  telephone?: string | null;
  cover_foot?: string | null;
  cover_head?: string | null;
  has_accepted_registration_invite?: boolean;
  /** @format date-time */
  pro_expiration_date?: string | null;
  coupon_code?: string | null;
  user_avatar_link?: string | null;
  user_company_link?: string | null;
  is_tour_ended?: string | null;
  is_admin?: boolean;
  site_language?: string | null;
  newsletter?: string | null;
  general_info?: string | null;
  planner_opacity?: number | null;
  preferred_currency_id?: number | null;
  field_of_interest_id?: number | null;
  seen_news_blog?: number | null;
  /** @format date-time */
  last_activity?: string | null;
  /** @format date-time */
  last_login?: string | null;
  planner_icon_set_id?: number | null;
  login_session_hash?: string | null;
  show_checklist_modal?: boolean | null;
  show_room_detected_modal?: boolean | null;
  show_auto_planning_modal?: boolean | null;
}

export interface UserCustomItems {
  /** This is the model class for table "user_custom_items". */
  id: number;
  user_id: number;
  icon_id: number;
  product_name: string;
  /** @format double */
  price_huf: number;
  /** @format double */
  price_eur: number;
  /** @format double */
  price_gbp: number;
  /** @format double */
  price_usd: number;
  /** @format double */
  price_czk: number;
  /** @format double */
  price_pln: number;
  /** @format double */
  price_chf: number;
  internal_product_manufacturer_id: number;
  user_manufacturer_id: number;
  comment: string;
  quote_image_url: string;
  details: string;
  is_auto_exchange: boolean;
  article_number: string;
}

export interface UserLabels {
  id: number;
  user_id: number;
  name: string;
  color: string;
  /** @format date-time */
  created_at: string;
}

/** Wall polygon point */
export interface WallPolies {
  /** This is the model class for table "wall_polies". */
  id: number;
  room_id: number;
  order_index: number;
  /** @format double */
  x: number;
  /** @format double */
  y: number;
}
